import { useEffect, useState } from 'react'

import api from 'core/api'
import { DEFAULT_SENDER_EMAIL } from '../functions/sender-email.function'

export const SENDER_EMAIL_SETTINGS_ENDPOINT =
  'StoreSettings/GetSenderEmailSettings'

// Without the store settings the domain is validated only by the backend
const FALLBACK_SETTINGS = {
  DefaultSenderEmail: DEFAULT_SENDER_EMAIL,
  DefaultSenderName: '',
  AllowedDomains: null
}

export const fetchSenderEmailSettings = async () => {
  try {
    const { data } = await api.get(SENDER_EMAIL_SETTINGS_ENDPOINT)

    return {
      DefaultSenderEmail: data?.DefaultSenderEmail || DEFAULT_SENDER_EMAIL,
      DefaultSenderName: data?.DefaultSenderName || '',
      AllowedDomains: data?.AllowedDomains ?? []
    }
  } catch {
    return FALLBACK_SETTINGS
  }
}

/**
 * Loads the store sender settings (default sender and allowed domains).
 * Returns null while loading.
 */
const useSenderEmailSettings = () => {
  const [settings, setSettings] = useState(null)

  useEffect(() => {
    let isMounted = true

    fetchSenderEmailSettings().then((result) => {
      if (isMounted) setSettings(result)
    })

    return () => {
      isMounted = false
    }
  }, [])

  return settings
}

export default useSenderEmailSettings
